import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/.pnpm/next@15.5.28_@types+node@22.5.4_react-dom@19.1.0_react@19.1.0__react@19.1.0_sass@1.77.4/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(frontend)/[locale]/[slug]/page.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ActivitiesBlock"] */ "/app/src/blocks/ActivitiesBlock/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AnreiseBlock"] */ "/app/src/blocks/AnreiseBlock/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ArchiveBlockClient"] */ "/app/src/blocks/ArchiveBlock/Component.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BulletPointsBlock"] */ "/app/src/blocks/BulletPointsBlock/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Code"] */ "/app/src/blocks/Code/Component.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EmblaSlider"] */ "/app/src/blocks/EmblaSlider/Component.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EmblaSlider"] */ "/app/src/blocks/EmblaSlider/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FormBlockClient"] */ "/app/src/blocks/Form/Component.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IframeBlockComponent"] */ "/app/src/blocks/IframeBlock/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImageGrid"] */ "/app/src/blocks/ImageGrid/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OffersBlockClient"] */ "/app/src/blocks/Offers/Component.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PricesBlockClient"] */ "/app/src/blocks/PricesBlock/Component.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RestaurantClient"] */ "/app/src/blocks/RestaurantBlock/Component.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReviewComponent"] */ "/app/src/blocks/Review/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SimpleImageGrid"] */ "/app/src/blocks/SimpleImageGrid/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SocialMediaBlock"] */ "/app/src/blocks/SocialMediaBlock/Component.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TextImageBlock"] */ "/app/src/blocks/TextImage/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WeatherClient"] */ "/app/src/blocks/WeatherBlock/Component.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WelcomeBlock"] */ "/app/src/blocks/WelcomeBlock/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ZimmerBlockClient"] */ "/app/src/blocks/ZimmerBlock/Component.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Hero"] */ "/app/src/components/Hero/Hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LivePreviewListener"] */ "/app/src/components/LivePreviewListener/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImageMedia"] */ "/app/src/components/Media/ImageMedia/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoMedia"] */ "/app/src/components/Media/VideoMedia/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderClient"] */ "/app/src/Header/Component.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/heros/HighImpact/seasonText.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MediumImpactHeroClient"] */ "/app/src/heros/MediumImpact/index.client.tsx");
